import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { ProxyServersSearchingForm, useGetAllProxyServersQuery } from '@/modules/ProxyServers';

import { ProxyServersListView } from './ProxyServersListView';

export const ProxyServersListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: proxyServersListData,
    error: proxyServersListError,
    isLoading: isProxyServersListLoading,
    isFetching: isProxyServersListFetching,
    isError: isProxyServersListError
  } = useGetAllProxyServersQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isProxyServersListLoading }
      error={ proxyServersListError }
      isError={ isProxyServersListError }
      data={ proxyServersListData }
    >
      { (proxyServersList): ReactElement => (
        <>
          <ProxyServersSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <ProxyServersListView
            currentPage={ currentPage }
            proxyServersListItems={ proxyServersList.items }
            proxyServersListTotalItems={ proxyServersList.meta.totalItems }
            proxyServersListItemsPerPage={ proxyServersList.meta.itemsPerPage }
            isLoading={ isProxyServersListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
